export const ZENDESK_SUBDOMAINS = {
    'de-DE': 'weltsparen-de',
    'de-AT': 'weltsparen-at',
    'en-GB': 'raisinuk',
    'en-US': 'raisin-eu',
    'fr-FR': 'raisin-fr',
    'nl-NL': 'raisin-nl',
    'en-IE': 'raisin-ie',
    'es-ES': 'raisin-es',
    'pl-PL': 'raisin-pl',
    'fi-FI': 'raisinfi',
    en: 'raisin-eu',
};
//# sourceMappingURL=zendesk.js.map